import { render } from "./OverviewProductHeros.vue?vue&type=template&id=6b96d2d2"
import script from "./OverviewProductHeros.vue?vue&type=script&lang=js"
export * from "./OverviewProductHeros.vue?vue&type=script&lang=js"

import "./OverviewProductHeros.vue?vue&type=style&index=0&id=6b96d2d2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__